/// <amd-module name="Wit/BoardsHub/Common/KanbanBoardConstants" />

export namespace BoardSettingsConstants {
    export const BoardSettingsPath = "KanbanBoard/Settings";
    export const ExpandedKey = "Expanded";
}

export const enum WorkItemSignalREventType {
    ItemUpdated = "Updated",
    ItemAdded = "Added",
    ItemDeleted = "Deleted",
    ItemRestored = "Restored",
    ItemCreated = "Created",
    ItemRemoved = "Removed"
}

export const boardPieceExpandedKey = (id: string) => `${BoardSettingsConstants.BoardSettingsPath}/${id}/${BoardSettingsConstants.ExpandedKey}`;
